import { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArchiveIcon from "@mui/icons-material/Archive";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";
import CardMenu from "./CardMenu";
import { toast } from "react-toastify";
import { customToastify } from "../../utils/utils";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import { Typography, IconButton, Divider, Box } from "@mui/material";

export default function TopOfCards(props) {
  const { alertButton, Info, cards } = props;
  const [groupCards, setGroupCards] = useState({ one: 0, ten: 0, other: 0 });

  const handleGroupCards = () => {
    let one = [cards["one"].length];
    let ten = [cards["two"].length];
    let other = [
      cards["three"].length +
      cards["four"].length +
      cards["five"].length +
      cards["six"].length +
      cards["seven"].length +
      cards["eight"].length +
      cards["nine"].length,
    ];
    // console.log("8888888888888888888888", cards["one"].length);
    setGroupCards({ one, ten, other });
  };
  useEffect(() => {
    if (cards) handleGroupCards();
  }, [cards]);

  return (
    <>
      <Box
        sx={{
          mx: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* <IconButton
          sx={{ p: 0.1, mx: 1, mt: 0 }}
          variant="contained"
          color="info"
          size="small"
        >
          <EditIcon />
        </IconButton> */}
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ color: "red", mx: 0.2 }}>
            {groupCards["one"]}
          </Typography>
          <Typography sx={{ color: "blue", mx: 0.2 }}>
            {groupCards["ten"]}
          </Typography>
          <Typography sx={{ color: "green", mx: 0.2 }}>
            {groupCards["other"]}
          </Typography>
        </Box>

        <IconButton
          sx={{ p: 0.1, mx: 1, mt: 0 }}
          variant="contained"
          color="info"
          size="small"
          onClick={() => {
            alertButton("home");
          }}
        >
          <ViewCarouselIcon />
        </IconButton>

        <IconButton
          sx={{ p: 0.1, mx: 1, mt: 0 }}
          variant="contained"
          color="info"
          size="small"
          onClick={() => {
            alertButton("back");
          }}
        >
          <KeyboardBackspaceIcon />
        </IconButton>
      </Box>
      <Divider
        sx={{
          textAlign: "center",
          fontSize: "small",
          color: (theme) =>
            theme.palette.reverse.status == "dark" ? "goldenrod" : "blue",
        }}
      >
        {Info["name"]}
      </Divider>
    </>
  );
}
